export var TAG_TYPES = {
  RANGE: "range"
};